import Component from "vamos/cockpit/Component";
import XMLView from "sap/ui/core/mvc/XMLView";

/**
 * @namespace vamos.cockpit.base.handler
 */
export default class ViewHandler {

    public static async getView(viewName: string, component: Component):Promise<XMLView> {
        let view:XMLView = component.getLoadedView(viewName);

        if (view) {
            return view;
        }

        view = await new Promise((resolve) => {
            component.runAsOwner(async () => {
                view = await XMLView.create({
                    viewName: viewName,
                }) ;
                component.setLoadedView(viewName, view);
                component.loadedViews[viewName] = view;
                component.getRootControl().addDependent(view);
                resolve(view);
            });
        });
        return view;

    }

}